"use client"

import { useDebounceFn } from "ahooks"
import { useEffect, useRef } from "react"

/**
 * 页面滚动时自动关闭下拉框/弹出层的 Hook
 * 当 open 为 true 时，监听页面滚动事件，滚动时自动调用 onClose 关闭
 * @param {boolean} open - 下拉框/弹出层的打开状态
 * @param {() => void} onClose - 关闭回调函数
 * @param {boolean} enabled - 是否启用滚动关闭功能，默认为 true
 */
export const useCloseOnScroll = (open: boolean, onClose: () => void, enabled: boolean = true): void => {
  const onCloseRef = useRef(onClose)

  const handleScroll = () => {
    onCloseRef.current()
  }

  const { run } = useDebounceFn(handleScroll, {
    wait: 300,
  })

  // 始终保存最新的 onClose 回调
  useEffect(() => {
    onCloseRef.current = onClose
  }, [onClose])

  useEffect(() => {
    if (!enabled || !open) return

    // 使用 passive 选项提升性能
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", run, { passive: true })
      document.addEventListener("click", handleScroll)
      return () => {
        window.removeEventListener("scroll", run)
        document.removeEventListener("click", handleScroll)
      }
    }
  }, [open, enabled])
}
